var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectBalancingPVPMapMaxUnitsProduction, selectBalancingPVPMapMinUnitsProduction, } from "../../balancingSelectors/selectBalancingPvPMapDefinitions";
import { IdResource } from "../../constants/IdResource";
import { MarketConstants } from "../../constants/MarketConstants";
import { IdStyles } from "../../less/IdStyles";
import { selectCurrentRunningPvPEventMapId } from "../../selectors/selectPVP";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { IdEventSoundCore } from "../../utils/sound/IdEventSoundCore";
import { utilCompatibility } from "../../utils/utilCompatibility";
import { ButtonWithProgress } from "../button-with-progress/ButtonWithProgress";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { ButtonSmallDelete } from "../generic/common/ButtonSmallDelete";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { InventoryResourceRequirement } from "../generic/inventory-resource-requirement/InventoryResourceRequirement";
import { TextLoca } from "../generic/text/TextLoca";
import { TooltipText } from "../tooltip";
import { actionContractRequestDismiss, actionContractRequestFulfill } from "./actionContractInfo";
import { ContractReward } from "./ContractReward";
import { DetailViewMarketTrashWaiting } from "./DetailViewMarketTrashWaiting";
import { MarketProfilePicture } from "./MarketProfilePicture";
import { MarketTimerCountdown } from "./MarketTimerCountdown";
var DetailViewMarketDOM = /** @class */ (function (_super) {
    __extends(DetailViewMarketDOM, _super);
    function DetailViewMarketDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getContractRequirements = function (orders) {
            return orders.map(function (order, index) {
                var id = order.id, amount = order.amount, resourceId = order.resourceId;
                // For IE
                var gridStyle = utilCompatibility.getMsGridPositions(index, 2);
                return (React.createElement("div", { key: id, style: gridStyle },
                    React.createElement(InventoryResourceRequirement, { required: amount, resourceId: resourceId })));
            });
        };
        _this.getFulfillContractState = function () {
            var _a = _this.props, fulfillContract = _a.fulfillContract, item = _a.item, contractCooldownTime = _a.contractCooldownTime;
            if (contractCooldownTime) {
                return (React.createElement(TooltipText, { id: IdLoca.tooltip_deliveryInProgress_web },
                    React.createElement(ButtonWithProgress, { disabled: true, duration: MarketConstants.ContractCooldownTime, remainingTime: contractCooldownTime },
                        React.createElement(MarketTimerCountdown, { remainingTime: contractCooldownTime }))));
            }
            return (React.createElement(TooltipText, { id: IdLoca.tooltip_fulfillContract_web },
                React.createElement(ButtonPrimary, { onClick: function () { return fulfillContract(item.contractId); } },
                    React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.send }))));
        };
        return _this;
    }
    DetailViewMarketDOM.prototype.render = function () {
        var _a = this.props, item = _a.item, pvpUnitsMax = _a.pvpUnitsMax, pvpUnitsMin = _a.pvpUnitsMin;
        if (!item) {
            return React.createElement(React.Fragment, null);
        }
        var visual = item.visual, orders = item.orders, remainingTime = item.remainingTime;
        var dismissContract = this.props.dismissContract;
        var contractRequirements = this.getContractRequirements(orders);
        var contractDetails = (React.createElement("div", { className: IdStyles.DetailViewWrapper + " flex flex--guts" },
            React.createElement("div", { className: "" + IdStyles.DetailView },
                React.createElement("div", { className: "market-menu" },
                    React.createElement("div", { className: "market-menu__info" },
                        visual && (React.createElement(MarketProfilePicture, { profileName: visual.profilePictureAsset })),
                        React.createElement("div", { className: "market-menu__rewards" },
                            React.createElement("div", { className: IdStyles.TextButtonHeading },
                                React.createElement(TextLoca, { id: IdLoca.rewards })),
                            React.createElement("div", { className: "market-menu__rewards-wrapper " + IdStyles.MarketMenuRewardsBackground },
                                React.createElement(ContractReward, { item: item, pvpUnitsMax: pvpUnitsMax, pvpUnitsMin: pvpUnitsMin })))),
                    React.createElement("div", { className: "market-menu__requirements " + IdStyles.MarketMenuRequirementsBackground }, contractRequirements),
                    React.createElement("div", { className: "market-menu__buttons" },
                        React.createElement(ButtonSmallDelete, { onClick: function () { return dismissContract(item.contractId); }, soundId: IdEventSoundCore.None },
                            React.createElement(Icon, { icon: IdIcon.TrashIcn, styleId: IdStyles.IconLarge })),
                        this.getFulfillContractState())))));
        return remainingTime ? (React.createElement(DetailViewMarketTrashWaiting, { item: item, remainingTime: remainingTime })) : (contractDetails);
    };
    return DetailViewMarketDOM;
}(React.PureComponent));
var mapState = function (state, ownProps) {
    var contractCooldownTime = state.contractInfo.cooldownTime;
    var dollarReward = ownProps.item
        ? ownProps.item.rewards.find(function (element) { return element.id === IdResource.Money; })
        : undefined;
    var pvpMapId = selectCurrentRunningPvPEventMapId(state);
    if (!dollarReward || pvpMapId == undefined) {
        return {
            contractCooldownTime: contractCooldownTime,
            pvpUnitsMax: 0,
            pvpUnitsMin: 0,
        };
    }
    return {
        contractCooldownTime: contractCooldownTime,
        pvpUnitsMax: selectBalancingPVPMapMaxUnitsProduction(pvpMapId),
        pvpUnitsMin: selectBalancingPVPMapMinUnitsProduction(pvpMapId),
    };
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        dismissContract: actionContractRequestDismiss,
        fulfillContract: actionContractRequestFulfill,
    }, dispatch);
};
export var DetailViewMarket = connect(mapState, mapDispatch)(DetailViewMarketDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/market/DetailViewMarket.tsx
// module id = 2712
// module chunks = 3